// THIS FILE IS SPECIAL, ALL `import`s HERE INCREASE PAGE LOAD TIMES!

// This is the entrypoint for a header.js. This file is to import librares so they are available inside <script> blocks.
// Import anything you plan to use here.
// Minimize the amount of imports here to optimize page load times.

import { Panzoom } from "@fancyapps/ui";
// import { Pins } from "@fancyapps/ui/dist/panzoom/panzoom.pins.esm.js"
import { Toolbar } from "@fancyapps/ui/dist/panzoom/panzoom.toolbar.esm.js";
import { ionRangeSlider } from "@oijs/vanilla-rangeslider";


// Add these objects to the window so they are available in .html files inline <script> blocks
window.jQuery = window.$ = require("jquery");
window.Panzoom = Panzoom;
window.Toolbar = Toolbar;

const OriginalIonRangeSlider = ionRangeSlider;
const RANGE_SLIDER_HOOKS = ["onStart", "onChange", "onFinish", "onUpdate"];
const rangeSliderNodes = new WeakMap();

function rangeSliderValueText(data, options) {
    const prefix = options.prefix || "";
    const postfix = options.postfix || "";
    const from = prefix + (data.from_value != null ? data.from_value : data.from_pretty) + postfix;
    if (options.type !== "double") {
        return from;
    }
    let to = prefix + (data.to_value != null ? data.to_value : data.to_pretty) + postfix;
    if (options.max_postfix && data.to === data.max) {
        to += options.max_postfix;
    }
    return from + " to " + to;
}

function rangeSliderNameLine(input) {
    const container = input.previousElementSibling;
    const line = container ? container.querySelector(".irs-line") : null;
    if (!line) {
        return null;
    }
    const descriptionId = input.id + "-a11y-value";
    let description = document.getElementById(descriptionId);
    if (!description) {
        description = document.createElement("span");
        description.id = descriptionId;
        description.className = "visually-hidden";
        input.insertAdjacentElement("afterend", description);
    }
    const label = document.querySelector('label[for="' + input.id + '"]');
    line.setAttribute("role", "group");
    line.setAttribute("aria-describedby", descriptionId);
    if (label && label.textContent.trim()) {
        line.setAttribute("aria-label", label.textContent.trim());
    }
    const nodes = { line, description };
    rangeSliderNodes.set(input, nodes);
    return nodes;
}

function rangeSliderA11y(input, options, data) {
    if (!input) {
        return;
    }
    let nodes = rangeSliderNodes.get(input);
    if (!nodes || !nodes.line.isConnected) {
        nodes = rangeSliderNameLine(input);
    }
    if (nodes && data) {
        nodes.description.textContent = rangeSliderValueText(data, options);
    }
}

window.ionRangeSlider = function (target, options = {}) {
    const input = typeof target === "string" ? document.querySelector(target) : target;
    const wrappedOptions = { ...options };
    RANGE_SLIDER_HOOKS.forEach((hook) => {
        const original = options[hook];
        wrappedOptions[hook] = function (data) {
            rangeSliderA11y(input, options, data);
            if (typeof original === "function") {
                original.call(this, data);
            }
        };
    });
    return OriginalIonRangeSlider(input, wrappedOptions);
};
